<customer-data-search
  [attr.lang]="locale()"
  [attr.auth-info]="authInfoJson()"
  [attr.base-url]="baseUrl"
  [attr.business-partner-id]="businessPartnerId()"
  enable-vehicle-selection
  hide-vin-search
  (selectVehicle)="handleSelectVehicle($event)"
  (openCustomerProfile)="handleOpenCustomerProfile($event)">
</customer-data-search>
